<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible.sync="modalVisible"
  >
    <template #header>分摊详情</template>
    <template #content>
      <app-filter-group class="gj-mb10" :reset="false">
        <gj-select-input
          v-model="keyword"
          :options="[
              {id: 'asin', text: 'ASIN'},
              {id: 'parentAsin', text: '父ASIN'},
              {id: 'msku', text: 'MSKU'},
              {id: 'sku', text: 'SKU'},
              {id: 'productName', text: '产品名称'},
          ]"
        >
        </gj-select-input>
        <gj-date-picker
          v-model="date"
          type="daterange"
        >
        </gj-date-picker>
      </app-filter-group>

      <gj-table
        :data="data"
        :columns="columns"
        :offset-height="35"
      >

      </gj-table>
    </template>
  </gj-modal>
</template>

<script>
    import {modalMixIn} from "../../../../../minxins";

    export default {
        name: "sharing-detail",
        mixins: [modalMixIn],
        props: {
            id: {

            }
        },
        data() {
            return {
                keyword: {
                    key: 'asin',
                    value: null,
                },
                date: [],
                columns: [
                    {id: 'market', header: '店铺/国家', field: 'marketName', minWidth: '120px',},
                    {id: 'picture', header: '图片', field: 'picture:picture', minWidth: '60px',},
                    {id: 'listingInfo', header: '商品标题/ASIN/MSKU', field: 'slot:listingInfo', minWidth: '250px',},
                    {id: 'date', header: '日期', field: 'date', minWidth: '150px',},
                    {id: 'avgPrice', header: '平均单价', field: 'avgPrice', minWidth: '150px',},
                    {id: 'sales', header: '销量', field: 'sales', minWidth: '120px',},
                    {id: 'salesAmount', header: '销售额', field: 'salesAmount', minWidth: '120px',},
                    {id: 'sharingTotal', header: '分摊总金额', field: 'slot:sharingTotal', minWidth: '120px',},
                    {id: 'daySharingPrice', header: '每日分摊金额', field: 'daySharingPrice', minWidth: '120px',},
                ],
                data: [
                    {}
                ],
            }
        }
    }
</script>

<style scoped>

</style>
